(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"), require("popper.js"), require("ui-bootstrap4"), require("bootstrap"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery", "popper.js", "ui-bootstrap4", "bootstrap"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jQuery"), require("popper.js"), require("ui-bootstrap4"), require("bootstrap")) : factory(root["jQuery"], root["popper.js"], root["ui-bootstrap4"], root["bootstrap"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0iPh__, __WEBPACK_EXTERNAL_MODULE_PO2U__, __WEBPACK_EXTERNAL_MODULE_yejP__, __WEBPACK_EXTERNAL_MODULE_ykxQ__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition